import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconColumns3Wide"><Path d="M8 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5C2 5.11929 3.11929 4 4.5 4H8V20Z" fill="currentColor"/><Path d="M15 20H9V4H15V20Z" fill="currentColor"/><Path d="M19.5 4C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H16V4H19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3Wide;
